<template>                
    <div class="row">
        <div class="col-lg-12">
            <div class="v-card v-sheet theme--light">
                <DinamicTableInfiniteLoader
                    :headers="table_headers"
                    :items="instant_inspections"
                    :search="search"
                    :pagination="pagination"
                    :checkable="true"
                    :link="'/qc-inspections/'"
                    name="table"
                    :updateable="true"
                    @emitToUpdate="$emit('modalUpdate', $event)"
                    @fetchMainList="fetchMainList($event)"
                    @paginateMoreRecords="paginateMoreRecords($event)"
                    ref="main_table"
                />
            </div>
        </div>
    </div>
</template>

<script>
import DinamicTableInfiniteLoader     from    '@/components/DinamicTableInfiniteLoader'

export default {

    name:   'InspectionView',

    props: [
        "table_headers",
        "form_data_filter",
        "search"
    ],

    components: {
        DinamicTableInfiniteLoader,
    },

    data(){
        return{
            single_select: false,
            table_selection: [],
            instant_inspections: [],
            pagination: null,
            rest_api_pagination: 'inspections_pagination',
        }
    },

    methods:{

        modal_update(index)
        {
            this.$emit('modalUpdate', index)
        },

        modal_deletion(index, value)
        {
            let object = {
                index: index,
                value: value,
                endpoint: 'instant_inspections',
                array_object: this.instant_inspections
            }
            this.$emit('modalDeletion', object)
        },

        async paginateMoreRecords(params)
        {
            if(this.instant_inspections.length >= this.pagination?.total)
            {
                return;
            }
            
            await this.showLoader()

            await this.apiRequest(params)
        },

        async fetchMainList(params) 
        {
            this.instant_inspections = [];
            await this.showLoader()
            await this.apiRequest(params, true)
        },


        async loadMoreRecords(data, reset_list)
        {
            if(reset_list)
            {
                this.instant_inspections = []
            }

            if(data.pagination.data.length)
            {
                data.pagination.data.forEach((item) => {
                    item.checked = this.$refs.main_table.select_all
                    this.instant_inspections.push(item)
                })
            }
            this.pagination = data.pagination

            await this.hideLoader(data.pagination.data)
        },

        async showLoader()
        {
            this.$refs.main_table.showLoader()
        },

        async hideLoader(data)
        {
            this.$refs.main_table.hideLoader(data)
        },

        resetList()
        {
            this.$refs.main_table.params['page'] = 1;
            this.fetchMainList(this.$refs.main_table.params)
        }
    },

    watch: {
         
        form_data_filter: {
            handler(val)
            {
                let keys = Object.keys(val);
                keys.forEach(item => 
                {
                    this.$refs.main_table.params[item] = val[item]
                });

                this.$refs.main_table.params['page'] = 1;
                this.fetchMainList(this.$refs.main_table.params)
            },
            deep: true
        },

    }
    
}
</script>

